





































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { TrimmingResult } from "./TrimmingResult";
import { Size } from "../../../domain/drawing/Size";

interface IDefaultSizeParameter {
  imageSize: {
    width: number;
    height: number;
  };
}

@Component({
  components: {
    Cropper,
  },
})
export default class TrimmingDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      imageSource: null as string,
      trimmingResult: null as TrimmingResult,
      isAppliable: false,
      isImageLoading: false,
    };
  }
  imageSource: string;
  trimmingResult: TrimmingResult;
  isAppliable: boolean;
  isImageLoading: boolean;

  $refs!: {
    cropper: Cropper,
  };
  
  async show(imageSource: string): Promise<TrimmingResult> {
    if (!imageSource) {
      throw new Error("画像が指定されていません。");
    }
    this.isImageLoading = true;
    this.imageSource = imageSource;
    this.trimmingResult = null;
    this.isAppliable = false;

    return this.showModal(async () => {
      await this.waitHidden();
      
      // 前回表示した結果が残るのでクリアしている
      this.imageSource = null;
      await this.$nextTick();

      return this.trimmingResult;
    });
  }

  getDefaultSize(param: IDefaultSizeParameter): { width: number; height: number } {
    return {
      width: param.imageSize.width,
      height: param.imageSize.height,
    };
  }

  onReady(): void {
    this.isImageLoading = false;
  }

  onChange(info: any): void {
    this.isAppliable = (info.image.width !== info.coordinates.width) || (info.image.height !== info.coordinates.height);
  }

  apply(): void {
    this.trimmingResult = this.createResult();
    this.isVisible = false;
  }

  private createResult(): TrimmingResult {
    const cropperResult = this.$refs.cropper.getResult();
    if (cropperResult.image.width === cropperResult.coordinates.width && cropperResult.image.height === cropperResult.coordinates.height) {
      // 元の画像と同じときは更新する必要無し
      return null;
    }
    const trimmingResult = new TrimmingResult();
    trimmingResult.size = new Size(cropperResult.coordinates.width, cropperResult.coordinates.height);
    trimmingResult.imageDataText = this.getImageDataTextFromCanvas(cropperResult.canvas);
    return trimmingResult;
  }

  private getImageDataTextFromCanvas(canvas: HTMLCanvasElement): string {
    if (!canvas) {
      throw new Error("画像データの取得に失敗しました。");
    }
    // TODO: 解像度の大きい画像は縮小もしたほうが良さそうではある
    const data = canvas.toDataURL("image/jpeg", 0.95);
    if (!data.startsWith("data:image/jpeg;base64,")) {
      throw new Error("画像データの取得に失敗しました。");
    }
    return data.substring(23);
  }

  cancel(): void {
    this.isVisible = false;
  }
}
